// extracted by mini-css-extract-plugin
export var dividerLine = "_8v-3";
export var itemImage = "_8v-9";
export var lightDivider = "_8v-4";
export var modalContent = "_8v-5";
export var modalContentCompact = "_8v-6";
export var productCard = "_8v-a";
export var productImage = "_8v-b";
export var productImageCompact = "_8v-7";
export var productImagePlaceholder = "_8v-c";
export var productImagePlaceholderCompact = "_8v-8";
export var progressBarBackground = "_8v-1";
export var progressBarContainer = "_8v-0";
export var progressBarFill = "_8v-2";